import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Sidebar.css';
import { ETestId } from '../../../common/constants';

interface ISidebarProps {
  children: React.ReactNode;
  opened: boolean;
}

export const Sidebar: React.FC<ISidebarProps> = ({ children, opened }) => {
  return (
    <div data-testid={ETestId.Sidebar} className={classNames(styles['container'], opened && styles['opened'])}>
      {children}
    </div>
  );
};

Sidebar.displayName = 'Sidebar';
